import { Box } from '@mui/material';

export function InstructionsPage() {
  return (
    <Box sx={{ height: 'calc(100dvh - 128px)', minHeight: 480, display: 'flex' }}>
      <Box
        component="iframe"
        src="/instrukcja.html"
        title="Instrukcja obsługi"
        sx={{
          flex: 1,
          width: '100%',
          border: '1px solid',
          borderColor: 'divider',
          borderRadius: 3,
          bgcolor: 'background.paper',
        }}
      />
    </Box>
  );
}
